import styled from '@emotion/styled';
import { colors } from 'crono-fe-common/theme';

export const LinkedinStatusBadgeWrapper = styled.span`
  font-size: 10px;
  line-height: 12px;
  font-weight: 500;
  min-width: 30px;
  height: 12px;
  display: inline-block;
  text-align: center;
  padding: 0px;
  cursor: default !important;
  color: ${colors.grey2};
`;
